module.exports = "/images/storm@2x.png?7617c313460f111b6e33ff284f25dc32";